import React from 'react';

interface ErrorDisplayProps {
  error: string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error }) => (
  <div className="bg-red-50 border-l-4 border-red-500 text-red-800 p-6 mb-8 rounded-2xl flex items-center gap-4 animate-fade-in">
    <span className="text-3xl" role="img" aria-label="error">❌</span>
    <div>
      <p className="font-bold text-lg mb-1">Произошла ошибка</p>
      <p className="text-sm">{error}</p>
    </div>
  </div>
);

export default ErrorDisplay;
